// TODO - remove becouse of legacy

import * as components from './components'

console.log('Quizzes feature initialized!')

export { components }
